import { IAuditFilters } from './types'

export const DEFAULT_AUDIT_FILTERS: IAuditFilters = {
  searchAdvanced: { field: 'ticket_token', query: '' },
  merchant: '',
}

export const DEFAULT_PER_PAGE = 50
export const PER_PAGE_OPTIONS = [25, 50, 100]
